// extracted by mini-css-extract-plugin
export default {"actions":"Button_actions__-KYau","actions2":"Button_actions2__txaAH","actions3":"Button_actions3__v4l+J"};